export const validateClassDiscountCode = (values: any, infoMessage: (message: string) => void): boolean => {
    if(!values.code){
        infoMessage('Please enter discount code')
        return false
    }
    if(!values.discount){
        infoMessage('Please enter discount')
        return false
    }
    if(!values.type){
        infoMessage('Please select discount type')
        return false
    }
    if(!values.admissionTicketIds || values.admissionTicketIds?.length === 0){
        infoMessage('Please select ticket type')
        return false
    }
    return true
}
